import { CreditCard, ErrorOutline } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Chip, styled } from '@mui/material';

const StyledButton = styled(Button)({
  fontWeight: '600',
  textTransform: 'capitalize',
  fontSize: '1rem',
  display: 'flex',
  gap: '4px',
});

type State =
  | 'loading'
  | 'validConcession'
  | 'expiredConcession'
  | 'noConcession'
  | 'patientInactive'
  | 'patientInactive with validConcession'
  | 'patientInactive with expiredConcession';

export type ConcessionChipProps = {
  state: State;
  onClick: () => void;
};

export const ConcessionChip = ({ onClick, state }: ConcessionChipProps) => {
  const renderChip = (
    label: string,
    icon: React.ReactElement | undefined,
    color: 'default' | 'warning' | 'success' = 'default',
    sx?: object,
    isDisabled: boolean = false,
  ) => (
    <Chip
      label={label}
      icon={icon}
      color={color}
      onClick={!isDisabled ? onClick : undefined}
      sx={{ ...sx, fontSize: '14px', fontWeight: '600' }}
    />
  );

  const renderAddConcessionButton = (isDisabled: boolean = false, isV3: boolean) => (
    <Box display="flex" flexDirection={isV3 ? 'row-reverse' : 'row'}>
      <StyledButton
        color={isV3 ? 'primary' : 'secondary'}
        variant="text"
        size="small"
        onClick={onClick}
        disabled={isDisabled}
        endIcon={<AddIcon />}
      >
        Add Concession Status
      </StyledButton>
    </Box>
  );

  switch (state) {
    case 'loading':
      return renderChip('Loading...', undefined, 'warning', undefined, true); // No icon here

    case 'validConcession':
      return renderChip('Concession holder', <CreditCard />, 'default', { backgroundColor: '#E6F1F9' });

    case 'expiredConcession':
      return renderChip('Concession card expired', <ErrorOutline color="error" />, 'default', {
        backgroundColor: '#F9E6E6',
      });

    case 'noConcession':
      return renderAddConcessionButton(false, true);

    case 'patientInactive':
      return renderAddConcessionButton(true, true);

    case 'patientInactive with validConcession':
      return renderChip('Concession holder', <CreditCard />, 'default', undefined, true);

    case 'patientInactive with expiredConcession':
      return renderChip('Concession card expired', <ErrorOutline />, 'default', undefined, true);

    default:
      return null;
  }
};

export default ConcessionChip;
